<i18n>
{
  "en": {
    "socialMediaActive": "The social media is active",
    "socialMediaNoActive": "The social media is not active",
    "edit": "Edit social media",
    "delete": "Delete social media"
  },
  "es": {
    "socialMediaActive": "La red social está activa",
    "socialMediaNoActive": "La red social no está activa",
    "edit": "Editar la red social",
    "delete": "Eliminar la red social"
  }
}
</i18n>
<template>
    <dynameat-row
    :title="`${socialMedia.name} / ${socialMedia.accountId}`"
    :description="socialMedia.url"
    :button-config-list="buttonConfigList"
    :collapse-items="!$vuetify.breakpoint.mdAndUp"
    @editSocialMedia="onEditSocialMedia"
    @deleteSocialMedia="onDeleteSocialMedia"
    :isClickable="false"
  >
    <template v-slot:rowIconsLeft>
      <v-tooltip class="pr-3" top v-if="socialMedia.isVisible"><template v-slot:activator="{ on, attrs }">
        <v-icon class="pr-3" v-bind="attrs" v-on="on" color="green" >mdi-check-circle</v-icon></template><span>{{$t('userActive')}}</span></v-tooltip>
      <v-tooltip top v-else><template v-slot:activator="{ on, attrs }">
        <v-icon class="pr-3" v-bind="attrs" v-on="on" color="grey">mdi-check-circle</v-icon></template><span>{{$t('userNoActive')}}</span></v-tooltip>
    </template>
    <template v-slot:aboveContent>
      <v-row align="center">
        <div :style="{height: '50px', width: 'auto', marginLeft: '10px'}">
        <img :src="socialMedia.icon" />
        </div>
      </v-row>
      <v-row align="center" class="chip-top">
        <v-chip v-for="pointOfSale in socialMediaPosList" :key="pointOfSale.guid" class="chip" x-small>{{ pointOfSale.name }}</v-chip>
      </v-row>
    </template>
  </dynameat-row>
</template>
<script>
import DynameatRow from '@dynameat/components/DynameatRow';
import Component from 'vue-class-component';
import { Components, MapGetters } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { SocialMedia } from '../models';

@Component
@Components({ DynameatRow })
@MapGetters(['pointOfSaleList'])
export default class SocialMediaRow extends Vue {
  @Prop({
    Object,
    validator(socialMedia) {
      return socialMedia instanceof SocialMedia;
    }
  }) socialMedia;

  get buttonConfigList() {
    return [
      {
        title: this.$t('edit'),
        icon: 'mdi-pencil',
        emitName: 'editSocialMedia',
      },
      {
        title: this.$t('delete'),
        icon: 'mdi-delete',
        emitName: 'deleteSocialMedia',
      }
    ];
  }

  get socialMediaPosList() {
    return this.pointOfSaleList.filter((item) => this.socialMedia.posGuidList.includes(item.guid));
  }

  onEditSocialMedia() {
    this.$emit('edit', this.socialMedia);
  }

  onDeleteSocialMedia() {
    this.$emit('delete', this.socialMedia);
  }
}
</script>
<style scoped>
.chip {
  margin-top: 5px;
  margin-right: 5px;
}
</style>
